export type Subscription = {
  unsubscribe: () => void
}

export class Subject<T> {
  protected listeners: ((value: T) => void)[] = []

  subscribe(listener: (value: T) => void): Subscription {
    this.listeners.push(listener)
    return {
      unsubscribe: () => {
        const index = this.listeners.indexOf(listener)
        if (index !== -1) {
          this.listeners.splice(index, 1)
        }
      }
    }
  }

  next(value: T): void {
    this.listeners.forEach((listener) => listener(value))
  }

  complete() {
    this.listeners = []
  }
}
